import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }
const _hoisted_3 = { class: "wad-topbar" }
const _hoisted_4 = { class: "wad-range-pills" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "wp-loading"
}
const _hoisted_7 = { class: "wp-loading__text" }
const _hoisted_8 = {
  key: 1,
  class: "alert alert-danger m-3"
}
const _hoisted_9 = { class: "wl-kpis mb-4" }
const _hoisted_10 = { class: "wl-stat wl-stat--dark wad-kpi-location" }
const _hoisted_11 = { class: "wl-stat__head" }
const _hoisted_12 = { class: "wl-stat__title" }
const _hoisted_13 = { class: "wl-stat__value wad-location-name" }
const _hoisted_14 = {
  key: 0,
  class: "wl-stat__meta"
}
const _hoisted_15 = { class: "wl-stat" }
const _hoisted_16 = { class: "wl-stat__head" }
const _hoisted_17 = { class: "wl-stat__title" }
const _hoisted_18 = {
  key: 0,
  class: "wl-stat"
}
const _hoisted_19 = { class: "wl-stat__head" }
const _hoisted_20 = { class: "wl-stat__title" }
const _hoisted_21 = { class: "wl-stat__value" }
const _hoisted_22 = { class: "wl-stat" }
const _hoisted_23 = { class: "wl-stat__head" }
const _hoisted_24 = { class: "wl-stat__title" }
const _hoisted_25 = { class: "wl-stat__value wad-ago" }
const _hoisted_26 = {
  key: 1,
  class: "wl-stat"
}
const _hoisted_27 = { class: "wl-stat__head" }
const _hoisted_28 = { class: "wl-stat__title" }
const _hoisted_29 = { class: "wl-stat__value wad-ago" }
const _hoisted_30 = { class: "wad-main row g-3" }
const _hoisted_31 = { class: "col-12 col-lg-4" }
const _hoisted_32 = { class: "assets-grid-card h-100" }
const _hoisted_33 = { class: "assets-grid-card__body p-3" }
const _hoisted_34 = { class: "col-12 col-lg-8" }
const _hoisted_35 = { class: "assets-grid-card" }
const _hoisted_36 = { class: "assets-grid-card__header" }
const _hoisted_37 = { class: "assets-grid-title" }
const _hoisted_38 = { class: "assets-grid-title__icon" }
const _hoisted_39 = { class: "assets-grid-title__text" }
const _hoisted_40 = { class: "text-muted small" }
const _hoisted_41 = { class: "assets-grid-card__body p-3" }
const _hoisted_42 = {
  key: 1,
  class: "text-center text-muted py-4"
}
const _hoisted_43 = {
  key: 0,
  class: "text-center text-muted py-4"
}
const _hoisted_44 = {
  key: 1,
  class: "wad-charts row g-3"
}
const _hoisted_45 = {
  key: 0,
  class: "col-12 col-md-6 wad-chart-block"
}
const _hoisted_46 = { class: "wad-chart-title" }
const _hoisted_47 = {
  key: 1,
  class: "col-12 col-md-6 wad-chart-block"
}
const _hoisted_48 = { class: "wad-chart-title" }
const _hoisted_49 = {
  key: 2,
  class: "col-12 col-md-6 wad-chart-block"
}
const _hoisted_50 = { class: "wad-chart-title" }
const _hoisted_51 = {
  key: 3,
  class: "col-12 col-md-6 wad-chart-block"
}
const _hoisted_52 = { class: "wad-chart-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WirepasJourneySidebar = _resolveComponent("WirepasJourneySidebar")!
  const _component_WirepasRouteMap = _resolveComponent("WirepasRouteMap")!
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "wad-back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.backToList')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rangeOptions, (h) => {
            return (_openBlock(), _createElementBlock("button", {
              key: h.v,
              type: "button",
              class: _normalizeClass(["wl-pill", { 'wl-pill--active': _ctx.rangeHours === h.v }]),
              onClick: ($event: any) => (_ctx.setRange(h.v))
            }, _toDisplayString(h.l), 11, _hoisted_5))
          }), 128))
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("span", {
              class: "spinner-border wp-loading__spinner",
              role: "status"
            }, null, -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('components.wirepasAssets.loading')), 1)
          ]))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.error), 1)
            ]))
          : (_ctx.data)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.location')), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-geo-alt wl-stat__icon" }, null, -1))
                    ]),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.data.location?.name || '—'), 1),
                    (_ctx.data.location?.gwId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.data.location.gwId), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('components.wirepasAssets.columns.status')), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-activity wl-stat__icon" }, null, -1))
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["wad-status", `wad-status--${_ctx.data.status}`])
                    }, _toDisplayString(_ctx.$t(`components.wirepasAssets.status.${_ctx.data.status}`)), 3)
                  ]),
                  (_ctx.data.batteryV !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.battery')), 1),
                          _cache[7] || (_cache[7] = _createElementVNode("i", {
                            class: "bi bi-battery-half wl-stat__icon",
                            style: {"color":"#f77f01"}
                          }, null, -1))
                        ]),
                        _createElementVNode("span", _hoisted_21, [
                          _createTextVNode(_toDisplayString(_ctx.data.batteryV?.toFixed(2)), 1),
                          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "wad-unit" }, "V", -1))
                        ]),
                        (_ctx.data.batteryPct !== null)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "wl-stat__accent",
                              style: _normalizeStyle({ width: `${_ctx.data.batteryPct}%`, background: _ctx.data.batteryPct < 20 ? '#dc3545' : '#3f8f52' })
                            }, null, 4))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.lastSeen')), 1),
                      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "bi bi-clock wl-stat__icon" }, null, -1))
                    ]),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.agoText(_ctx.data.lastSeen)), 1)
                  ]),
                  (_ctx.data.sinceAtLocation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.sinceAtLocation')), 1),
                          _cache[10] || (_cache[10] = _createElementVNode("i", {
                            class: "bi bi-clock-history wl-stat__icon",
                            style: {"color":"#4870b8"}
                          }, null, -1))
                        ]),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.durText(_ctx.data.sinceAtLocation)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_WirepasJourneySidebar, {
                          legs: _ctx.data.journey ?? []
                        }, null, 8, ["legs"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.tracking ? 'bi bi-map' : 'bi bi-graph-up')
                            }, null, 2)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.tracking ? _ctx.$t('components.wirepasAssets.detail.routeMap') : _ctx.data.name || _ctx.data.serialNumber), 1),
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.data.deviceModel) + " · " + _toDisplayString(_ctx.data.serialNumber), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["wad-toggle", { 'wad-toggle--active': _ctx.tracking }]),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tracking = !_ctx.tracking))
                        }, [
                          _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-map me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.trackingMode')), 1)
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        (_ctx.tracking)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.legsWithCoords.length)
                                ? (_openBlock(), _createBlock(_component_WirepasRouteMap, {
                                    key: 0,
                                    legs: _ctx.data.journey ?? []
                                  }, null, 8, ["legs"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-geo me-2" }, null, -1)),
                                    _createTextVNode(_toDisplayString(_ctx.$t('components.wirepasAssets.detail.noCoords')), 1)
                                  ]))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!_ctx.hasSeries)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-bar-chart-line me-2" }, null, -1)),
                                    _createTextVNode(_toDisplayString(_ctx.$t('components.wirepasAssets.detail.noData')), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    (_ctx.data.series.rssi.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                          _createElementVNode("div", _hoisted_46, [
                                            _cache[14] || (_cache[14] = _createElementVNode("i", {
                                              class: "bi bi-reception-4",
                                              style: {"color":"#f77f01"}
                                            }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.rssi')) + " [dBm]", 1)
                                          ]),
                                          _createVNode(_component_LineChart, {
                                            "chart-data": _ctx.rssiChartData,
                                            options: _ctx.chartOptions('dBm'),
                                            height: 140
                                          }, null, 8, ["chart-data", "options"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.data.series.temperature.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                          _createElementVNode("div", _hoisted_48, [
                                            _cache[15] || (_cache[15] = _createElementVNode("i", {
                                              class: "bi bi-thermometer-half",
                                              style: {"color":"#f77f01"}
                                            }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.temperature')) + " [°C]", 1)
                                          ]),
                                          _createVNode(_component_LineChart, {
                                            "chart-data": _ctx.tempChartData,
                                            options: _ctx.chartOptions('°C'),
                                            height: 140
                                          }, null, 8, ["chart-data", "options"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.data.series.humidity.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                          _createElementVNode("div", _hoisted_50, [
                                            _cache[16] || (_cache[16] = _createElementVNode("i", {
                                              class: "bi bi-droplet-half",
                                              style: {"color":"#f77f01"}
                                            }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.humidity')) + " [%]", 1)
                                          ]),
                                          _createVNode(_component_LineChart, {
                                            "chart-data": _ctx.humChartData,
                                            options: _ctx.chartOptions('%'),
                                            height: 140
                                          }, null, 8, ["chart-data", "options"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.data.series.battery.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                          _createElementVNode("div", _hoisted_52, [
                                            _cache[17] || (_cache[17] = _createElementVNode("i", {
                                              class: "bi bi-battery-half",
                                              style: {"color":"#f77f01"}
                                            }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.battery')) + " [V]", 1)
                                          ]),
                                          _createVNode(_component_LineChart, {
                                            "chart-data": _ctx.battChartData,
                                            options: _ctx.chartOptions('V'),
                                            height: 140
                                          }, null, 8, ["chart-data", "options"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                            ], 64))
                      ])
                    ])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
    ])
  ]))
}